import { effect, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { LabsDialogComponent } from '@app/+authenticated/labs-dialog/labs-dialog.component';
import { SbDialogService } from '@sb/ui/dialog';
import { map } from 'rxjs';

export const LABS_QUERY_PARAM = 'labs-open';

@Injectable({ providedIn: 'root' })
export class LabsDeepLinkService {
  #route = inject(ActivatedRoute);
  #dialog = inject(SbDialogService);

  #shouldOpenLabsDialog = toSignal(
    this.#route.queryParamMap.pipe(map((params) => params.get(LABS_QUERY_PARAM) === 'true')),
  );

  #hasOpened = false;

  constructor() {
    effect(() => {
      if (this.#hasOpened) {
        return;
      }
      if (this.#shouldOpenLabsDialog()) {
        this.#hasOpened = true;

        // Deferred to a macrotask so the dialog does not open from inside the
        // current change detection cycle.
        setTimeout(() => this.#dialog.open(LabsDialogComponent, {}));
      }
    });
  }
}
